(function () {
  // 如果 URL 包含 customer_posted=true，说明订阅成功，直接跳转
  if (window.location.search.includes('customer_posted=true')) {
    window.location.replace('/products/j');
  }
})();
